import React from 'react'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import { AgentFeature } from '.'
import { AgentFeaturesQueryResult } from '../../graphql/schema/queries/agent-features'
import { FetchPolicy } from 'apollo-client'

export const agentFeaturesQuery = gql`
  query AgentFeatures {
    agentFeatures {
      features {
        name
        languages
      }
    }
  }
`

interface ChildProps {
  readonly features?: AgentFeature[]
  readonly loading: boolean
}

export interface Props {
  readonly render: (props: ChildProps) => React.ReactNode
  readonly fetchPolicy?: FetchPolicy
  readonly skipQuery?: boolean
}

interface QueryResult {
  readonly agentFeatures: AgentFeaturesQueryResult
}

export function AgentFeaturesLoader({ render, fetchPolicy, skipQuery }: Props) {
  const isAuthPath =
    window.location.href.includes('signin') ||
    window.location.href.includes('logout')

  const shouldSkipQuery = skipQuery !== undefined ? skipQuery : isAuthPath

  return (
    <Query<QueryResult, {}>
      query={agentFeaturesQuery}
      fetchPolicy={fetchPolicy}
      errorPolicy="all"
      skip={shouldSkipQuery}
    >
      {({ loading, data, error }) => {
        if (error) {
          throw new Error(error.message)
        }

        const features =
          data && data.agentFeatures && data.agentFeatures.features

        return render({
          loading,
          features: features as AgentFeature[]
        })
      }}
    </Query>
  )
}
